const REDIRECT_TRACE_KEY = "__tp_last_redirect_to_index__";
let redirectStarted = false;

function getBlockedPageUrl() {
  return `${window.location.origin}/blocked.html`;
}

export function redirectToIndex(reason = "unknown", payload = {}) {
  const target = getBlockedPageUrl();

  if (redirectStarted) return true;
  redirectStarted = true;

  console.error("[BLOCKED_REDIRECT]", {
    reason,
    from: window.location.href,
    target,
    payload
  });
  console.error(`[BLOCKED_REDIRECT] target=${target}`);

  try {
    sessionStorage.setItem(
      REDIRECT_TRACE_KEY,
      JSON.stringify({
        reason,
        payload,
        from: window.location.href,
        target,
        at: new Date().toISOString()
      })
    );
  } catch (e) {
    // Ignore storage failures (private mode / quota / disabled storage).
  }

  window.stop();

  // Set href directly so this works in the deployed page and in embedded browsers.
  window.location.href = target;

  // Fallback for runtimes that ignore a location write.
  setTimeout(() => {
    if (window.location.href !== target) {
      window.location.assign(target);
    }
  }, 80);

  return true;
}

export function readLastRedirectTrace() {
  try {
    return sessionStorage.getItem(REDIRECT_TRACE_KEY);
  } catch (e) {
    return null;
  }
}
